// extracted by mini-css-extract-plugin
module.exports = {"container":"_2c_Py","extraMarginTop":"slbe7","badgeContainer":"_1j8Hr","badge":"PSSaj","date":"_2ZSgf","time":"_20tEd"};